<template>
	<div class="position">
		<header>
			<div
			 class="city"
			 @click="showPicker"
			>{{cityQuery}}</div>
			<div class="search">
				<img
				 src="@/assets/images/index/search_icon.png"
				 alt
				>
				<input
				 type="text"
				 placeholder="请输入地址"
				 @focus="showSearch"
				 @blur="hideSearch"
				 v-model="query"
				>
				<img
				 src="@/assets/images/close_gray.png"
				 alt
				 class="close"
				 v-show="query"
				 @click="clear"
				>
			</div>
			<div
			 class="cancel"
			 v-show="false"
			>确定</div>
		</header>
		<section
		 class="result autoCompleteContainer"
		 v-show="showSearchList"
		>
			<div
			 class="addressList"
			 v-show="searchResult.length>0"
			>
				<div
				 class="addressItem"
				 v-for="(address,index) in searchResult"
				 @click="selectAutoCompleteAddress(address)"
				 :key="index"
				>
					<div class="addressText">{{address.title}}
						<div
						 class="rightText"
						 v-show="false"
						>1.8km</div>
					</div>
					<div class="addressMore">{{address.address}}</div>
				</div>
			</div>
			<div
			 class="noItem"
			 v-show="searchResult.length == 0"
			>暂无搜索结果</div>
		</section>
		<div
		 class="map"
		 id="map"
		></div>
		<footer>
			<div class="top">请选择楼宇位置或者
				<div
				 class="rightBtn"
				 @click="rePositioning"
				>
					<img
					 src="@/assets/images/re_pos.png"
					 alt
					>
					重新定位
				</div>
			</div>
			<div
			 class="addressList"
			 v-show="addressList.length>0"
			>
				<div class="warp">
					<div
					 class="addressItem"
					 @click="selectedAddress(address,index)"
					 v-for="(address,index) in addressList"
					 :key="index"
					>
						<div
						 class="point"
						 :class="{'selected':index == addressIndex}"
						></div>
						<div class="address">
							{{address.title}}
							<div class="addressMore">{{address.address}}</div>
						</div>
						<div class="rightText">距离定位点{{(address.distance)}}</div>
					</div>

				</div>
			</div>
			<div
			 class="noAddress"
			 v-show="addressList.length == 0"
			>没找到所在办公楼？
				<br>更多办公楼，敬请期待
			</div>
		</footer>
	</div>
</template>

<script>
import Vue from "vue";
import picker from "@/plugins/better-picker";
Vue.use(picker);
import $localStorage from "@/utils/localStorage.js";
import { area } from "@/interface/site";
import debounce from "@/utils/debounce.js";
import { weixin } from "@/utils/wxconfig";
import bdMap from "@/utils/bdMap";
export default {
	props: {
		popup: false
	},
	data() {
		return {
			isShow: this.popup,
			query: "",
			map: null,
			point: null,
			local: null,
			addressIndex: 0,
			searchResult: [],
			showSearchList: false,
			cityList: [],
			cityQuery: ""
		};
	},
	computed: {
		addressList() {
			return this.searchResult.map(v => {
                let distance = 0;
                if (v.distance) {
                    distance = v.distance;
                   
				} else {
                    distance = this.map
                        .getDistance(this.point, v.point)
                        .toFixed(2);
                }
                if (distance > 1000) {
					distance = (distance / 1000).toFixed(2) + "km";
				} else {
					distance += "m";
				}
                v.distance = distance;
				return v;
			});
		},
		cityIndex() {
			let cityIndex = 0;
			if (this.cityQuery && this.cityList.length > 0) {
				let reg = new RegExp(this.cityQuery);
				this.cityList.forEach((v, index) => {
					if (reg.test(v.content)) {
						cityIndex = index;
					}
				});
			}
			return cityIndex;
		}
	},
	watch: {
		cityQuery(newValue) {
			if (newValue) {
				this.local = new BMap.LocalSearch(newValue, {
					onSearchComplete: this.onSearchComplete
				});
			}
		},
		query: debounce(
			function(newValue) {
				if (newValue != "") {
					this.local.search(newValue);
				}
			},
			500,
			1000
		)
	},
	mounted() {
		weixin.config();
		this.map = new BMap.Map("map", {
			enableHighResolution: true
		});
		// 移动监听事件
		this.map.addEventListener("dragend", () => {
			this.map.clearOverlays();
			this.point = this.map.getCenter();
			var marker = new BMap.Marker(this.point); // 创建标注
			this.map.addOverlay(marker);
			bdMap.getAddress(
				{
					longitude: this.point.lng,
					latitude: this.point.lat
				},
				data => {
					this.searchResult = data.surroundingPois;
					this.cityQuery = data.addressComponents.city;
				}
			);
		});


		this.local = new BMap.LocalSearch(this.map, {
			renderOptions: { map: this.map },
			onSearchComplete: this.onSearchComplete
		});
		this.rePositioning();

		// 获取市列表
		this.getCities();
	},
	methods: {
		rePositioning() {
			weixin.getLocation(res => {
				this.point = new BMap.Point(res.lng, res.lat);
				// 地图移动当前位置到中心点
				this.map.centerAndZoom(this.point, 15);
				var marker = new BMap.Marker(this.point); // 创建标注
				this.map.addOverlay(marker);

				bdMap.getAddress(
					{
						longitude: res.lng,
						latitude: res.lat
					},
					data => {
						this.searchResult = data.surroundingPois;
						this.cityQuery = data.addressComponents.city;
					}
				);
			});
		},
		// 搜索地址回调
		onSearchComplete(res) {
			let arr = [];
			for (let i = 0; i < res.getCurrentNumPois(); i++) {
				arr.push(res.getPoi(i));
			}
			this.searchResult = arr;
		},
		clear() {
			this.query = "";
		},
		selectedAddress(address, index) {
			let data = {
				point: address.point,
				city: address.city,
				province: address.province,
				title: address.title,
				uid: address.uid,
				detail: address.address
			};
			$localStorage.set("selectedAddress", data);
			this.isShow = false;
			this.$nextTick(() => {
				this.$emit("checked", { params: data, isShow: this.isShow });
			});
		},
		// 获取市列表
		getCities() {
			area().then(res => {
				this.cityList = res.result.map((v, index) => ({
					...v,
					value: v.content,
					text: v.content
				}));
				if(this.$picker.instance){
					this.$picker.destroy();
				}
				this.$picker.init(
					{
						data: [this.cityList]
					},
					{
						selectFn: (selectedVal, selectIndex) => {
							[this.cityQuery] = selectedVal;
							this.query = "";
							this.searchResult = [];
						}
					}
				);
			});
		},
		showPicker() {
			this.$picker.scrollColumn(0, this.cityIndex);
		},
		showSearch() {
			this.searchResult = [];
			this.showSearchList = true;
		},
		hideSearch() {
			this.showSearchList = false;
		},
		selectAutoCompleteAddress(item) {
			this.query = item.title;
			this.showSearchList = false;
		}
	},
	components: {}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.position {
	@include square(100%);
	@include dis-flex;
	flex-direction: column;
	padding-top: px2rem(110);
}
header {
	width: 100%;
	background-color: white;
	@include dis-flex(center);
	padding: px2rem(20) 0;
	@include black-box-shadow;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 10000;
	.city {
		padding: 0 px2rem(64) 0 px2rem(30);
		font-size: px2rem(28);
		color: #303234;
		white-space: nowrap;
		@include triangle(
			$bg: transparent,
			$arrow: down,
			$pos: (
				50% 30 auto auto
			)
		);
		&::before,
		&::after {
			transform: translateY(-25%);
		}
	}
	.search {
		@include square(100%, 70);
		@include dis-flex(center);
		background-color: #f7f7f7;
		border-radius: px2rem(10);
		border: px2rem(1) solid #e4e4e4;
		padding: 0 px2rem(20);
		margin-right: px2rem(20);
		img {
			flex: 0 0 auto;
			display: block;
			margin-right: px2rem(16);
			height: px2rem(26);
			&.close {
				height: px2rem(36);
				margin: 0;
			}
		}
		input {
			flex: 1 0 auto;
			display: block;
			background-color: transparent;
			font-size: px2rem(26);
			color: #a6a6a6;
		}
	}
	.cancel {
		font-size: px2rem(28);
		color: #7b7f81;
		padding: 0 px2rem(20) 0 0;
		white-space: nowrap;
	}
}
.map {
	width: 100%;
	flex: 1;
	background-color: black;
	&::before {
		content: "";
		display: block;
		padding-top: 100%;
	}
}
footer {
	height: px2rem(450);
	@include dis-flex;
	flex-direction: column;
	.top {
		@include square(100%, 70);
		@include dis-flex(center, space-between);
		background-color: #f7f8fa;
		padding: 0 px2rem(20);
		border-left: border(#73c6c8, 8);
		border-bottom: border();
		color: #545b5b;
		font: {
			size: px2rem(28);
			weight: 300;
		}
		.rightBtn {
			@include dis-flex(center);
			padding-right: px2rem(20);
			color: #73c6c8;
			font-weight: 300;
			img {
				display: block;
				margin-right: px2rem(10);
				@include square(30);
			}
		}
	}
	.addressList {
		padding: 0 px2rem(20);
		counter-reset: address;
		flex: 1;
		@extend %overflow-scroll;
		.addressItem {
			padding: px2rem(30) 0 px2rem(70);
			border-bottom: border(#e4e4e4);
			@include dis-flex(center);
			.point {
				@include square(28, 34);
				font-size: 0;
				line-height: 0;
				padding: 0;
				color: white;
				text-align: center;
				margin-right: px2rem(14);
				background: {
					size: 100% 100%;
					position: center;
					repeat: no-repeat;
					image: url("~@/assets/images/point_gray.png");
				}
				&::before {
					counter-increment: address;
					content: counter(address);
					display: inline;
					font: {
						size: px2rem(24);
						weight: 300;
					}
					line-height: px2rem(30);
				}
				&.selected {
					background-image: url("~@/assets/images/point_cyan.png");
				}
			}
			.rightText {
				font-size: px2rem(28);
				color: #303234;
				font-weight: 300;
				line-height: 1;
			}
			.address {
				@extend .rightText;
				position: relative;
				flex: 1 0 0;
				font-weight: normal;
				.addressMore {
					@include pos-a(40);
					font: {
						size: px2rem(22);
						weight: 300;
					}
					color: #a6a6a6;
				}
			}
		}
	}
	.noAddress {
		width: 100%;
		padding: px2rem(10) 0;
		flex: 1;
		@include dis-flex(center, center);
		background-color: #f4f4f4;
		font-size: px2rem(24);
		color: #545b5b;
		line-height: px2rem(36);
		text-align: center;
	}
}
.autoCompleteContainer {
	z-index: 10;
	background-color: #ffffff;
	position: fixed;
	top: 0;
	left: 0;
	@include square(100%);
	padding: px2rem(110) px2rem(20) px2rem(30);
	.addressList {
		.addressItem {
			padding: px2rem(30) 0 px2rem(20);
			&:not(:last-child) {
				border-bottom: px2rem(1) solid #e4e4e4;
			}
			.addressText {
				font-size: px2rem(28);
				color: #303234;
				line-height: 1;
				@include dis-flex(center, space-between);
			}
			.addressMore {
				margin-top: px2rem(10);
				font-size: px2rem(26);
				color: #a6a6a6;
			}
		}
	}
	.noItem {
		width: 100%;
		text-align: center;
		margin-top: px2rem(100);
		font-size: px2rem(28);
		color: #7b7f81;
	}
}
</style>
